import React, { useEffect, useState } from "react";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import { Formik, Form, FieldArray } from "formik";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import StepRoutes from "../../../Routes/steps_routes";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { ScrumSystemSchema } from "../../../Schemas/Scrum System/scrum_system_schema";
import { ScrumSysInfo, ScrumLineItemInfo } from "../../../SchemaInfo/info";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcMoneyTransfer, FcSurvey } from "react-icons/fc";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import { FcServiceMark } from "react-icons/fc";
import CustomCheckbox from "../../../CustomComponent/custom_checkbox";
import { extractDate } from "../../../Components/Functions/date.fun";

const ConductScrum = () => {
  const [loading, setLoading] = useState(false);
  const [leadOwner, setLeadOwner] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const [scrumInfo, setScrumInfo] = useState(ScrumSysInfo);
  const [lastTask, setlastTask] = useState([]);
  const [empId, setEmpId] = useState();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const queryId = searchParams.get("duplicate");

    if (queryId) {
      setLoading(true);
      performRequest("GET", `/scrumMeeting/scrumMeetingById/${queryId}`)
        .then((res) => {
          if (res.status === 200) {
            // console.log("data is", res.data.lineItems);
            const { createdAt, updatedAt, ...rest } = res?.data || {};

            // Remove scrumUpdate from all lineItems
            const cleanedLineItems = (rest.lineItems || []).map((item) => {
              const { scrumUpdate, ...restItem } = item;
              return restItem;
            });

            setScrumInfo({ ...rest, lineItems: cleanedLineItems });
          } else {
            Toast("error", "Error while getting PO!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  }, [location.search]);

  const formatDate = () => {
    const d = new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}/${month}/${day}`;
  };

  const handelSubmit = (values, actions) => {
    if (values?.id) {
      const { id, ...rest } = values;
      values = rest;
    }

    values = {
      ...values,
      lineItems: values.lineItems.map((item) => ({
        ...item,
        empDate: formatDate(),
      })),
    };

    setLoading(true);
    performRequest("POST", "/scrumMeeting/create-scrum-meeting/", values)
      .then((res) => {
        if (res.status === 200) {
          navigate("/scrum-meetings");
          Toast("success", "Scrum Meeting Created Successfully!");
        } else {
          Toast("error", "Error while Creating");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => setLeadOwner(res?.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  useEffect(() => {
    if (!scrumInfo?.lineItems?.length) return;

    scrumInfo.lineItems.forEach((item, index) => {
      if (!item?.eid) return;

      performRequest("GET", `/scrumMeeting/lastscrumById/${item.eid}`)
        .then((res) => {
          if (res.status === 200) {
            const filterDat = res.data
              .flatMap((meeting) => meeting.lineItems || [])
              .filter((li) => Number(li.eid) === Number(item.eid))
              .slice(0, 3); // ✅ only last 3
            setlastTask((prev) => ({
              ...prev,
              [index]: filterDat,
            }));
          }
        })
        .catch(CustomErrorResponse);
    });
  }, [scrumInfo]);

  const checkTouched = (obj) => {
    if (
      obj.deliveryDate === "" &&
      obj.gstRate === "" &&
      obj.itemPrice === "" &&
      obj.itemQuantity === "" &&
      obj.itemUnit === "" &&
      obj.notes === "" &&
      obj.particulars === ""
    ) {
      return false;
    } else {
      return true;
    }
  };
  if (loading) {
    return <LoadingPage />;
  }

  // const getIdFun = (id, index) => {
  //   // Clear previous employee tasks for this row only
  //   setlastTask((prev) => ({ ...prev, [index]: [] }));

  //   performRequest("GET", `/scrumMeeting/lastscrumById/${id}`)
  //     .then((res) => {
  //       if (res.status === 200) {
  //         const filterDat = res.data
  //           .flatMap((meeting) => meeting.lineItems || [])
  //           .filter((item) => Number(item.eid) === Number(id));

  //         // Save tasks for THIS row only
  //         setlastTask((prev) => ({ ...prev, [index]: filterDat }));
  //       }
  //     })
  //     .catch((err) => CustomErrorResponse(err))
  //     .finally(() => setLoading(false));
  // };

  const getIdFun = (id, index) => {
    setlastTask((prev) => ({ ...prev, [index]: [] }));

    performRequest("GET", `/scrumMeeting/lastscrumById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          const filterDat = res.data
            .flatMap((meeting) => meeting.lineItems || [])
            .filter((item) => Number(item.eid) === Number(id))
            .slice(0, 3);

          setlastTask((prev) => ({
            ...prev,
            [index]: filterDat,
          }));
        }
      })
      .catch(CustomErrorResponse);
  };

  const getEmployeeName = (id) => {
    // If ID not exists
    if (!id) return <div>No Employee Selected</div>;

    // Manually search from your leadOwner array (faster + no API needed)
    const emp = leadOwner?.find((e) => Number(e.id) === Number(id));

    if (!emp) return <div>Employee Not Found</div>;

    return (
      <div className="p-2 border rounded bg-light mt-2">
        <strong style={{ color: "black", fontSize: "12px" }}>Name:</strong>{" "}
        <span style={{ color: "black", fontSize: "12px" }}>{emp.userName}</span>
      </div>
    );
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcServiceMark />
                  Scrum Meeting
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">Conduct New Scrum Meeting</h2>
            </div>

            <Formik
              initialValues={scrumInfo}
              validationSchema={ScrumSystemSchema}
              onSubmit={handelSubmit}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Conduct Metting
                      </label>
                      <div className="w-100 col d-flex align-items-center gap-3">
                        <div className="form-check">
                          <input
                            type="radio"
                            id="scrumMetting"
                            name="conductMetting"
                            value="Scrum"
                            className="form-check-input"
                            onChange={props.handleChange}
                            checked={props.values.conductMetting === "Scrum"}
                          />
                          <label
                            htmlFor="scrumMetting"
                            className="form-check-label"
                          >
                            Scrum
                          </label>
                        </div>

                        <div className="form-check">
                          <input
                            type="radio"
                            id="demoMetting"
                            name="conductMetting"
                            value="Demo"
                            className="form-check-input"
                            onChange={props.handleChange}
                            checked={props.values.conductMetting === "Demo"}
                          />
                          <label
                            htmlFor="demoMetting"
                            className="form-check-label"
                          >
                            Demo
                          </label>
                        </div>
                      </div>

                      {props.touched.conductMetting &&
                        props.errors.conductMetting && (
                          <p className="text-danger">
                            {props.errors.conductMetting}
                          </p>
                        )}
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        {`${
                          props.values.conductMetting === "Demo"
                            ? "Demo"
                            : "Scrum"
                        } Meeting Title`}
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="title" />
                        {props.touched.title && props.errors.title && (
                          <p className="text-danger">{props.errors.title}</p>
                        )}
                      </div>
                    </div>

                    {props?.values?.conductMetting === "Demo" ? (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3 ">
                          Departments
                        </label>
                        <div className="w-100 col">
                          <CustomSelect type="text" name="depName">
                            <option value="">Select</option>
                            <option value="Business Development Department">
                              Business Development Department (Sales)
                            </option>
                            <option value="Operations Executive Department">
                              Operations Executive Department (Purchase)
                            </option>
                            <option value="IT Department">IT Department</option>
                            <option value="Social Media Marketing Department">
                              Social Media Marketing Department (Video Editing,
                              Graphic Design)
                            </option>
                            <option value="Human Resources">
                              Human Resources Department
                            </option>
                            <option value="Accounting Department">
                              Accounting Department
                            </option>
                            <option value="Management Department">
                              Management Department
                            </option>
                            <option value="Agronomist Department">
                              Agronomist Department
                            </option>
                          </CustomSelect>
                          {props.touched.depName && props.errors.depName && (
                            <p className="text-danger">
                              {props.errors.depName}
                            </p>
                          )}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Date</label>
                      <div className="w-100 col">
                        <CustomInput type="date" name="date" />
                        {props.touched.date && props.errors.date && (
                          <p className="text-danger">{props.errors.date}</p>
                        )}
                      </div>
                    </div>

                    {props?.values?.conductMetting === "Demo" ? (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Demo Updates
                        </label>
                        <div className="w-100 col">
                          <CustomTextArea
                            type="text"
                            name="demoUpdates"
                            rows={15}
                            style={{ resize: "none" }}
                          />
                          {props.touched.demoUpdates &&
                            props.errors.demoUpdates && (
                              <p className="text-danger">
                                {props.errors.demoUpdates}
                              </p>
                            )}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                    {props?.values?.conductMetting === "Scrum" ? <hr /> : ""}
                    {props?.values?.conductMetting === "Scrum" ? (
                      <h3>Employee Updates :</h3>
                    ) : (
                      ""
                    )}
                    {props?.values?.conductMetting === "Scrum" ? <hr /> : ""}
                    {props?.values?.conductMetting === "Scrum" ? (
                      <FieldArray name="lineItems">
                        {({ push, remove }) => (
                          <div>
                            {props.values.lineItems.map((lineItem, index) => (
                              <div key={index}>
                                <div className="row g-3 align-items-center">
                                  <div className="col-12 col-md-2 col-lg-2">
                                    <label className=" form-label ">
                                      Select Employee
                                    </label>

                                    <div className="w-100 col">
                                      <CustomSelect
                                        type="text"
                                        name={`lineItems[${index}].eid`}
                                        value={
                                          props?.values?.lineItems?.[index]?.eid
                                        }
                                        onChange={(e) => {
                                          props.setFieldValue(
                                            `lineItems[${index}].eid`,
                                            e.target.value
                                          );
                                          getIdFun(e.target.value, index);
                                        }}
                                      >
                                        <option value="">Select</option>
                                        {leadOwner &&
                                          leadOwner?.map((state, index) => (
                                            <option
                                              key={index}
                                              value={state?.id}
                                            >
                                              {state?.userName}
                                            </option>
                                          ))}
                                      </CustomSelect>
                                    </div>
                                  </div>

                                  <div className="col-12 col-md-6 col-lg-6">
                                    <label className=" form-label ">
                                      Scrum Meeting Update
                                    </label>
                                    <div className="w-100 col">
                                      <CustomTextArea
                                        type={"text"}
                                        name={`lineItems[${index}].scrumUpdate`}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-1 col-lg-1 ms-md-4 ms-lg-4 ">
                                    <label className=" form-label ">
                                      Present
                                    </label>
                                    <div className="w-100 col">
                                      <CustomCheckbox
                                        type="checkbox"
                                        height={"20px"}
                                        width={"20px"}
                                        name={`lineItems[${index}].present`}
                                      ></CustomCheckbox>
                                      {props.touched.present &&
                                        props.errors.present && (
                                          <p className="text-danger">
                                            {props.errors.present}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-1 col-lg-1">
                                    <label className=" form-label ">
                                      Absent
                                    </label>
                                    <div className="w-100 col">
                                      <CustomCheckbox
                                        type="checkbox"
                                        height={"20px"}
                                        width={"20px"}
                                        name={`lineItems[${index}].absent`}
                                      ></CustomCheckbox>
                                      {props.touched.absent &&
                                        props.errors.absent && (
                                          <p className="text-danger">
                                            {props.errors.absent}
                                          </p>
                                        )}
                                    </div>
                                  </div>

                                  <div className="col-md">
                                    <button
                                      className="col-3 btn btn-primary text-end"
                                      style={{
                                        width: "100px",
                                        height: "30px",
                                      }}
                                      type="button"
                                      onClick={() => remove(index)}
                                    >
                                      Remove
                                    </button>
                                  </div>
                                </div>
                                <div className="row g-3 mt-2">
                                  {(lastTask[index] || []).map((item, i) => (
                                    <div key={i} className="col-12 col-md-4">
                                      <div
                                        className={`card shadow-sm border-0 ${
                                          item.present
                                            ? "bg-green-lt"
                                            : "bg-red-lt"
                                        }`}
                                        style={{
                                          borderRadius: "10px",
                                          padding: "8px", // smaller inner spacing
                                          minHeight: "140px", // 🔥 reduced height
                                        }}
                                      >
                                        <div
                                          className="card-body"
                                          style={{ padding: "8px" }}
                                        >
                                          {item?.empDate && (
                                            <h5
                                              className="ms-2 badge bg-primary"
                                              style={{ color: "white" }}
                                            >
                                              {item?.empDate}
                                            </h5>
                                          )}
                                          {/* Name */}
                                          <h6
                                            className="fw-bold mb-1"
                                            style={{ fontSize: "12px" }}
                                          >
                                            {getEmployeeName(item.eid)}
                                          </h6>

                                          <hr className="mt-1 mb-1" />

                                          {/* Scrum Update */}
                                          <p
                                            style={{
                                              fontSize: "11px",
                                              marginBottom: "4px",
                                            }}
                                          >
                                            <strong className="ms-1">
                                              Employee Update:
                                            </strong>
                                          </p>

                                          <div
                                            className="card p-2 fw-bold mb-1"
                                            style={{
                                              fontSize: "11px",
                                              minHeight: "40px",
                                            }}
                                          >
                                            <ul>
                                              {(item?.scrumUpdate || "N/A")
                                                .trim()
                                                .toLowerCase()
                                                .split("\n")
                                                .filter(
                                                  (line) => line.trim() !== ""
                                                )
                                                .map((line, index) => {
                                                  const sentenceCase =
                                                  line.trim().charAt(0).toUpperCase() + line.trim().slice(1);
                                            
                                                return <li key={index}>{sentenceCase}</li>
})}
                                            </ul>
                                          </div>

                                          <hr className="mt-1 mb-1" />

                                          {/* Present / Absent */}
                                          {item.present && (
                                            <span
                                              className="badge px-2 py-1"
                                              style={{ fontSize: "10px" }}
                                            >
                                              PRESENT
                                            </span>
                                          )}

                                          {item.absent && (
                                            <span
                                              className="badge px-2 py-1"
                                              style={{ fontSize: "10px" }}
                                            >
                                              ABSENT
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>

                                <hr />
                              </div>
                            ))}

                            <button
                              className="btn btn-primary mt-2 me-2"
                              type="button"
                              // disabled={
                              //   props.values.paymentfor === "Vendor Payment"
                              // }
                              onClick={() => {
                                if (props.values.lineItems.length === 0) {
                                  push({
                                    ...ScrumLineItemInfo,
                                  });
                                } else if (
                                  props.values.lineItems.length > 0 &&
                                  checkTouched(
                                    props.values.lineItems[
                                      props.values.lineItems.length - 1
                                    ]
                                  )
                                ) {
                                  push({
                                    ...ScrumLineItemInfo,
                                  });
                                } else {
                                  Toast(
                                    "error",
                                    "Please fill at least one line item field."
                                  );
                                }
                              }}
                            >
                              Add Employee Details
                            </button>
                            {/* <button
                            className="btn btn-primary mt-2"
                            type="button"
                            // disabled={
                            //   props.values.paymentfor === "Vendor Payment"
                            // }
                            onClick={() => {
                              if (props.values.lineItems.length === 0) {
                                push({
                                  ...ScrumLineItemInfo,
                                  itemFrom: "custom",
                                });
                              } else if (
                                props.values.lineItems.length > 0 &&
                                checkTouched(
                                  props.values.lineItems[
                                    props.values.lineItems.length - 1
                                  ]
                                )
                              ) {
                                push({
                                  ...ScrumLineItemInfo,
                                  itemFrom: "custom",
                                });
                              } else {
                                Toast(
                                  "error",
                                  "Please fill at least one line item field."
                                );
                              }
                            }}
                          >
                            Add Employee Details
                          </button> */}
                          </div>
                        )}
                      </FieldArray>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      {/* <FormSubmitButton buttonText="Submit Request For Payment" /> */}
                      <FormSubmitButton
                        buttonText={`Submit ${
                          props?.values?.conductMetting === "Demo"
                            ? "Demo"
                            : "Scrum"
                        } Meeting Details`}
                        // disabled={props.isSubmitting || loading}
                      />

                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ConductScrum;
